import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MdExpandMore } from 'react-icons/md';

function pathMatches(pathname, item) {
  if (!item?.path) return false;
  if (item.end) return pathname === item.path;
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}

function groupContainsPath(group, pathname) {
  return (group.children || []).some((child) => pathMatches(pathname, child));
}

function NavItem({ item, onClose }) {
  const { path, label, icon: Icon, end } = item;
  return (
    <NavLink
      to={path}
      end={end}
      className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
      onClick={onClose}
    >
      {Icon ? <Icon className="sidebar-link-icon" /> : null}
      <span>{label}</span>
    </NavLink>
  );
}

export default function SidebarNav({ items, onClose }) {
  const { pathname } = useLocation();
  const activeGroupId = (items || []).find((item) => item.children && groupContainsPath(item, pathname))?.id || '';
  const [openId, setOpenId] = useState(activeGroupId);

  useEffect(() => {
    if (activeGroupId) setOpenId(activeGroupId);
  }, [activeGroupId]);

  return (
    <nav className="sidebar-nav">
      {(items || []).map((item) => {
        if (item.children) {
          const open = openId === item.id;
          const active = groupContainsPath(item, pathname);
          const GroupIcon = item.icon;
          return (
            <div key={item.id} className={`sidebar-group${open ? ' open' : ''}${active ? ' active' : ''}`}>
              <button
                type="button"
                className={`sidebar-group-toggle${open ? ' open' : ''}${active ? ' active' : ''}`}
                aria-expanded={open}
                onClick={() => setOpenId((current) => (current === item.id ? '' : item.id))}
              >
                {GroupIcon ? <GroupIcon className="sidebar-link-icon" /> : null}
                <span>{item.label}</span>
                <MdExpandMore className="sidebar-group-chevron" />
              </button>
              {open ? (
                <div className="sidebar-group-children">
                  {item.children.map((child) => (
                    <NavLink
                      key={child.path}
                      to={child.path}
                      end={child.end}
                      className={({ isActive }) =>
                        `sidebar-link sidebar-link-child${isActive ? ' active' : ''}`
                      }
                      onClick={onClose}
                    >
                      {child.icon ? <child.icon className="sidebar-link-icon" /> : null}
                      <span>{child.label}</span>
                    </NavLink>
                  ))}
                </div>
              ) : null}
            </div>
          );
        }
        return <NavItem key={item.path} item={item} onClose={onClose} />;
      })}
    </nav>
  );
}
